module.exports = __webpack_public_path__ + "static/media/ecos_Stockholm_2.ab5e1ea3.jpg";